import DomainRights from 'common/types/domainRights';
import { FeatureFlags } from '@socrata/platform/feature-flags';
import _ from 'lodash';

const domainModules = _.get(window, 'socrata.modules');
const userFlags = _.get(window, 'socrata.currentUser.flags');
const currentUser = _.get(window, 'socrata.currentUser', {});
const usersRights = _.get(currentUser, 'rights');

export const canSeeCreateAssetsDialog = () => {
  if (!currentUser) {
    return false;
  }
  return (
    isSuperAdmin() ||
    canCreateDatasets() ||
    canCreateMeasures() ||
    canCreateESRIMapLayers() ||
    canCreateStories()
  );
};

export const canCreateMeasures = () => {
  if (!currentUser) {
    return false;
  }
  return (
    FeatureFlags.valueOrDefault('open_performance_standalone_measures') &&
    (isSuperAdmin() || _.includes(usersRights, DomainRights.create_measures))
  );
};

export const canCreateStories = () => {
  if (!currentUser) {
    return false;
  }
  return (
    FeatureFlags.valueOrDefault('stories_enabled') &&
    (isSuperAdmin() || _.includes(usersRights, DomainRights.create_story))
  );
};

export const canCreateDatasets = () => {
  if (!currentUser) {
    return false;
  }
  return isSuperAdmin() || _.includes(usersRights, DomainRights.create_datasets);
};

export const canCreateESRIMapLayers = () => {
  if (!currentUser || !_.get(domainModules, 'esri_integration', false)) {
    return false;
  }
  return isSuperAdmin() || _.includes(usersRights, DomainRights.create_datasets);
};

export const isSuperAdmin = () => {
  if (!currentUser) {
    return false;
  }
  return _.includes(userFlags, 'admin');
};

// AI reporting is gated on the ff, checked again by the reporting SPA at boot
// Super admins are refused by the reporting OAuth proxy so don't offer the way in.
export const canSeeReportingPreview = () =>
  FeatureFlags.valueOrDefault('enable_ai_reporting') && !isSuperAdmin();
